import {InitCommand} from "slotworks/commands/comms/init-command";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SettingsModel from "slotworks/model/settings/settings-model";
import SmartButton from "slotworks/smart-button/smart-button";
import SoundManager from "slotworks/sound/sound-manager";
import State from "slotworks/state-machine/states/state";

export default class Init extends State {

    public onEnter() {
        InitCommand().then(() => this.startGame());
    }

    protected startGame() {
        Layers.jumpToDefaultScene();
        SmartButton.init();
        Components.init();

        Components.betBar.setBalance(GameState.getCurrentGame().startBalance);
        Components.betMenu.setBalance(GameState.getCurrentGame().startBalance);

        Components.paytable.init(BetModel.generateBetOptions());

        Components.header.setMode(SettingsModel.playMode);

        if (!SoundManager.getMuted()) {
            SoundManager.unmute();
        }

        this.complete();

    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/init.ts